import React, { useState, useEffect, useRef } from 'react'
import classnames from 'classnames'

import { motion } from 'framer-motion'

import { ReactComponent as IconUp } from 'static/svg/chevron-up.svg'

import { PatientEligibility } from 'components/PatientEligibility/PatientEligibility'

const CreditsPanel = ({
  isEnterprise,
  isCorporate,
  isCareplus,
  isCassi,
  isCapitation,
  professionalProfileRole,
  hasButton,
  setHasButton,
  planGroupName,
  creditsStatus,
  availableCredits,
  maxCredits,
  enableDetails,
  validDate,
  expired,
  errorButton,
  loadingButton,
  solicitationDate,
  isUnlimited,
  startDate,
  corporateEligibility,
  loading,
  isPsiqProfile,
  isProfessionalProfile,
  onClickRequestCreditsButton,
  forceUpdate,
  psychiatryEligibility,
  psychiatryEligibilityLoading,
  onRequestTreatement,
  planGroupCode,
  reasonCode,
  planCode,
  creditsPanelErrorMessage,
  username,
  showRequestPsychiatryTreatmentButton,
  patientPlans,
}) => {
  const creditsPanelElement = useRef(null)
  const [ open, setOpen ] = useState(null)
  const [initialDragValue, setInitialDragValue] = useState(0)

  // Estilos
  const panelStyle = classnames('CreditsPanel', {
    'CreditsPanel--closed': !open
  })
  const iconStyle = classnames('CreditsPanel__icon', {
    'CreditsPanel__icon--up': !open
  })

  const onDragEnd = (_, info) => setOpen(!(initialDragValue < info.point.y))

  const onDragStart = (_, info) => setInitialDragValue(info.point.y)

  useEffect(() => {
    setOpen(true)
  }, [])

  //Muda o posicionamento do octadesk de acordo com a abertura do componente
  useEffect(() => {
    if (window.innerWidth < 1096) {
      const octadeskChatElement = document.getElementById('octadesk-octachat-appchat')
      const containerHeight = creditsPanelElement.current.clientHeight // Descontando a altura da gaveta do modal

      if (octadeskChatElement) {
        octadeskChatElement.style.bottom = `${containerHeight}px`
      }
    }
  }, [open])

  useEffect(() => {
    return () => {
      const octadeskChatElement = document.getElementById('octadesk-octachat-appchat')

      if (octadeskChatElement) {
        octadeskChatElement.style.bottom = 0
      }
    }
  }, [])

  return (
    <motion.div 
      className={panelStyle} 
      ref={creditsPanelElement}
      drag="y"
      dragConstraints={{ bottom: 0, top: 0 }}
      onDragEnd={onDragEnd}
      onDragStart={onDragStart}
      data-cy='credits-panel'
    >
      <div className="CreditsPanel__top" onClick={() => setOpen(prevState => !prevState)}>
        <IconUp className={iconStyle} />
      </div>
      <div className="CreditsPanel__container">
        <PatientEligibility 
          variant='creditsPanel'
          isPsiqProfile={isPsiqProfile}
          professionalProfileRole={professionalProfileRole}
          isProfessionalProfile={isProfessionalProfile}
          showRequestTreatment={isEnterprise || isCapitation}
          isEnterprise={isEnterprise}
          isCareplus={isCareplus}
          isCassi={isCassi}
          isCapitation={isCapitation}
          isCorporate={isCorporate}
          hasButton={hasButton}
          setHasButton={setHasButton}
          planGroupName={planGroupName}
          creditsStatus={creditsStatus}
          availableCredits={availableCredits}
          maxCredits={maxCredits}
          enableDetails={enableDetails}
          validDate={validDate}
          expired={expired}
          errorButton={errorButton}
          loadingButton={loadingButton}
          solicitationDate={solicitationDate}
          isUnlimited={isUnlimited}
          startDate={startDate}
          onClickRequestCreditsButton={onClickRequestCreditsButton}
          corporateEligibility={corporateEligibility}
          loading={loading}
          forceUpdate={forceUpdate}
          psychiatryEligibility={psychiatryEligibility}
          psychiatryEligibilityLoading={psychiatryEligibilityLoading}
          onRequestTreatement={onRequestTreatement}
          planGroupCode={planGroupCode}
          reasonCode={reasonCode}
          planCode={planCode}
          creditsPanelErrorMessage={creditsPanelErrorMessage}
          username={username}
          showRequestPsychiatryTreatmentButton={showRequestPsychiatryTreatmentButton}
          patientPlans={patientPlans}
        />
      </div>
    </motion.div>
  )

}

export { CreditsPanel }
